import { motion } from "framer-motion";

export default function OtpInput({ otp, setOtp, onVerify, otpTimeLeft, onResendOtp, isLoading = false }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoading) return;
    if (onVerify) onVerify();
  };


  return (
    <motion.form
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* OTP Field */}
      <div className="mb-2">
        <label className="form-label fw-semibold text-secondary">
          Enter OTP
        </label>
        <motion.input
          whileFocus={{ scale: 1.05 }}
          type="text"
          className="form-control form-control-lg text-center fw-bold fs-3 rounded-pill shadow-sm"
          placeholder="••••"
          maxLength={4}
          value={otp}
          onChange={(e) => setOtp && setOtp(e.target.value)}
          style={{
            letterSpacing: "8px",
            boxShadow: "inset 4px 4px 8px #c9c9c9, inset -4px -4px 8px #ffffff",
          }}
        />
      </div>

      {/* Countdown */}
      {otpTimeLeft > 0 ? (
        <p className="text-center text-secondary mb-3">
          OTP expires in {Math.floor(otpTimeLeft / 60)}:
          {String(otpTimeLeft % 60).padStart(2, "0")} minutes
        </p>
      ) : (
        <p className="text-center text-danger mb-3">
          OTP expired. Please resend.
        </p>
      )}

      {/* Verify Button */}
      {/* Verify Button */}
      <motion.button
        whileHover={!isLoading ? { scale: 1.05, y: -2 } : {}}
        whileTap={!isLoading ? { scale: 0.95, y: 2 } : {}}
        type="submit"
        className="btn btn-lg w-100 fw-bold rounded-pill d-flex justify-content-center align-items-center"
        style={{
          background: "linear-gradient(145deg, #43e97b, #38f9d7)",
          color: "white",
          boxShadow: "6px 6px 12px #c9c9c9, -6px -6px 12px #ffffff",
        }}
        disabled={isLoading || otpTimeLeft <= 0} // ✅ hard lock
      >
        {isLoading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
            />
            Verifying...
          </>
        ) : (
          "Verify OTP"
        )}
      </motion.button>

      {/* Resend OTP */}
      <div className="text-center mt-3">
        <a
          href="#"
          className={`fw-semibold text-decoration-none ${isLoading ? "text-muted" : "text-primary"
            }`}
          style={{ pointerEvents: isLoading ? "none" : "auto" }} // ✅ prevent spam
          onClick={(e) => {
            e.preventDefault();
            if (!isLoading && onResendOtp) onResendOtp();
          }}
        >
          Resend OTP
        </a>
      </div>
    </motion.form>
  );
}
